/**
* 系统管理  客户管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.orgName" placeholder="输入名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.contact" placeholder="输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.contactPhone" placeholder="输入联系人电话"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          size="small"
          v-model="queryParams.validTime"
          type="datetime"
          placeholder="选择机构有效期设置"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" style="width: 100%" clearable v-model="queryParams.lx" placeholder="请选择客户类型">
          <el-option
            v-for="x in lxList"
            :label="x.dictLabel"
            :value="x.dictValue"
            :key="x.dictValue">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <!--        <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button>-->
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="clientList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="lx" label="客户类型">
        <template slot-scope="scope">
          {{ scope.row.lx == 1 ? '机构客户' : '渠道客户' }}
        </template>
      </el-table-column>

      <el-table-column prop="orgName" label="名称">
        <template slot-scope="scope">
          <span v-if="scope.row.lx == 1">
            {{ scope.row.orgName }}
          </span>
          <el-link v-if="scope.row.lx == 2" type="primary" @click="openOrg(scope.row)">
            <span>{{ scope.row.orgName }}</span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="orgAddress" label="地址">
        <template slot-scope="scope">
          {{ scope.row.orgAddress != 'null' ? scope.row.orgAddress : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系人"/>
      <el-table-column prop="contactPhone" label="电话"/>
      <el-table-column prop="validTime" label="机构有效期设置"/>
      <el-table-column prop="price" label="卡价格设置"/>
      <el-table-column prop="psr" label="分成比例（%）"/>
      <el-table-column prop="qdTitle" label="H5标题"/>
      <el-table-column prop="url" label="二维码" width="80">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.url"
            style="width: 58px; height: 58px"
            :src="scope.row.url"
            :fit="'fill'"
            :preview-src-list="[scope.row.url]"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="freeUrl" label="体验二维码" width="100">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.freeUrl"
            style="width: 58px; height: 58px"
            :src="scope.row.freeUrl"
            :fit="'fill'"
            :preview-src-list="[scope.row.freeUrl]"></el-image>
        </template>
      </el-table-column>

      <el-table-column align="center"  label="操作" width="300">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.lx == 1"
            class="item"
            effect="dark"
            content="礼品卡激活"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-link"
              @click="handleQrCode(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-dropdown v-if="scope.row.lx == 2" @command="(command)=>{handleCommand(scope.row, command)}">
            <el-button size="mini" icon="el-icon-link" style="margin-right: 10px;"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">购买链接</el-dropdown-item>
              <el-dropdown-item command="2">体验链接</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-upload
            v-if="scope.row.lx == 1"
            style="display: inline-block; margin-left: 10px; "
            ref="upload11"
            class="upload-demo"
            accept=".jpg,.png"
            :action="url"
            :file-list="fileList"
            :on-success="
                  (response, file) => {
                      return uploadAttach(response, file, scope.row);
                    }
                  "
            :before-upload="beforeAvatarUpload"
            :limit="1">
            <el-tooltip
              class="item"
              effect="dark"
              content="上传"
              placement="top"
            >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-upload2"
                @click="handleUpload(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </el-upload>


          <!-- 渠道用户 -->
          <el-upload
            v-if="scope.row.lx == 2"
            style="display: inline-block; margin-left: 10px; "
            ref="upload11"
            class="upload-demo"
            accept=".jpg,.png"
            :action="url"
            :file-list="fileList"
            :on-success="
                  (response, file) => {
                      return uploadAttach(response, file, scope.row);
                    }
                  "
            :before-upload="beforeAvatarUpload"
            :limit="1">
            <el-tooltip
              class="item"
              effect="dark"
              content="购买二维码上传"
              placement="top"
            >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-upload2"
                @click="handleUpload(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </el-upload>

          <el-upload
            v-if="scope.row.lx == 2"
            style="display: inline-block; margin-left: 10px; "
            ref="upload12"
            class="upload-demo"
            accept=".jpg,.png"
            :action="url"
            :file-list="fileList"
            :on-success="
                  (response, file) => {
                      return uploadTestAttach(response, file, scope.row);
                    }
                  "
            :before-upload="beforeAvatarUpload"
            :limit="1">
            <el-tooltip
              class="item"
              effect="dark"
              content="体验二维码上传"
              placement="top"
            >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-upload"
                @click="handleUpload(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </el-upload>

        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="客户类型" prop="lx">
          <el-select size="small" style="width: 100%" clearable v-model="form.lx" placeholder="请选择客户类型">
            <el-option
              v-for="x in lxList"
              :label="x.dictLabel"
              :value="x.dictValue"
              :key="x.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="form.lx == 1 ? '机构名称' : '渠道名称'" prop="orgName">
          <el-input size="small" maxLength="255" v-model="form.orgName" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="联系人" prop="contact">
          <el-input size="small" maxLength="255" v-model="form.contact" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="contactPhone">
          <el-input size="small" maxLength="11" v-model="form.contactPhone" placeholder="请输入电话"></el-input>
        </el-form-item>

        <el-form-item label="卡价格设置" prop="price">
          <el-input size="small" maxLength="200" v-model="form.price" placeholder="请输入卡价格设置"></el-input>
        </el-form-item>

        <el-form-item label="地址" prop="orgAddress" v-if="form.lx == 1">
          <el-input size="small" maxLength="255" v-model="form.orgAddress" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="有效期设置" prop="validTime" v-if="form.lx == 1">
          <el-date-picker
            size="small"
            v-model="form.validTime"
            type="datetime"
            placeholder="选择机构有效期设置"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分成比例（%）" prop="psr" v-if="form.lx == 2">
          <el-input size="small" maxLength="5" v-model="form.psr" placeholder="请输入分成比例（%）" @input="formatInportData($event,'3,2','psr',form)"></el-input>
        </el-form-item>
        <el-form-item label="H5标题" prop="qdTitle" v-if="form.lx == 2">
          <el-input size="small" maxLength="30" v-model="form.qdTitle" placeholder="请输入H5标题"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="ljTitle"
      :visible.sync="ljOpen"
      width="30%" :close-on-click-modal="false">
      <div style="max-height:500px;overflow:auto"> {{ msg }}</div>
    </el-dialog>

    <el-dialog
      title="提现信息"
      :visible.sync="txOpen"
      width="30%" :close-on-click-modal="false">
      <div style="max-height:500px;overflow:auto">
        <el-descriptions class="margin-top" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              总售卡金额
            </template>
            {{ txInfoItem.gkPrice }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              分成金额
            </template>
            {{ txInfoItem.fcPrice }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              剩余可提现金额
            </template>
            {{ txInfoItem.dtxPrice }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              已提现金额
            </template>
            {{ txInfoItem.ytxPrice }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import {
  deleteOrg,
  getQrCodeLink, getTestLink,
  queryOrgDetail,
  queryOrgList,
  removeUser,
  saveOrg,
  updateOrg,
  uploadQrCode, uploadTestLink
} from "../../api/userMG";
import {formatInportData} from "../../utils/util";
import {queryTxInfo} from "../../api/order";

export default {
  name: "orgManage",
  components: {Pagination},
  data() {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[345789]\d{9}$/
      if (value != undefined && value != '') {
        if (regMobile.test(value)) {
          return callback()
        }
        // 返回一个错误提示
        callback(new Error('请输入合法的手机号码'))
      } else {
        callback()
      }
    }
    return {
      loading: false, //是显示加载
      title: '添加客户',
      editFormShow: false, //控制编辑页面显示与隐藏

      clientList: [],
      queryParams: {
        page: 1,
        size: 10
      },
      // 编辑与添加
      form: {},
      // rules表单验证
      rules: {
        lx: [
          { required: true, message: '请选择客户类型', trigger: 'blur' }
        ],
        orgName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入卡价格设置', trigger: 'blur' }
        ],
      },

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      url: '/api/common/upload',
      fileList: [],

      txOpen: false,
      txInfoItem: {},     // 渠道用户 提现信息

      ljTitle: '链接',
      ljOpen: false,
      msg: '',
      lxList: [
        { dictLabel: '机构客户', dictValue: '1' },
        { dictLabel: '渠道客户', dictValue: '2' },
      ]
    }
  },

  created() {
    this.initDate()
  },

  methods: {
    formatInportData,
    initDate() {
      this.getdata()
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },

    // 获取数据方法
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      queryOrgList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.clientList = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    //搜索事件
    search() {
      /*if (this.queryParams.query.areaCode) {
        this.queryParams.query.areaCode = this.queryParams.query.areaCode[this.queryParams.query.areaCode.length - 1]
      }*/
      this.getdata()
    },

    // 查看渠道用户 提现金额
    openOrg(row) {
      queryTxInfo({orgId: row.orgId}).then(res => {
        if(res.code == 200) {
          this.txInfoItem = res.data;

          this.txOpen = true;
        }
      })
    },

    handleQrCode(index, row) {
      getQrCodeLink(row.orgId).then(res => {
        if (res.code == 200) {
          this.msg = res.data;
          this.ljTitle = '链接';
          this.ljOpen = true;
          /*this.$alert(res.data, '链接', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
          });*/
        }
      })
    },

    // 渠道用户 获取连接
    handleCommand(item, command) {
      if(command == 1) {
        getQrCodeLink(item.orgId).then(res => {
          if (res.code == 200) {
            this.msg = res.data;
            this.ljTitle = '购买链接';
            this.ljOpen = true;
          }
        })
      } else if(command == 2) {
        getTestLink(item.orgId).then(res => {
          if (res.code == 200) {
            this.msg = res.data;
            this.ljTitle = '体验链接';
            this.ljOpen = true;
          }
        })
      }
    },

    // 上传 二维码
    uploadAttach(res, file, item) {
      var params = {
        url: res.data.url,
        orgId: item.orgId
      }
      uploadQrCode(params).then(res => {
        if (res.code == 200) {
          this.getdata()
          this.$message.success('上传成功！');
          this.$refs.upload11.clearFiles();
          this.fileList = [];
          // this.$refs.upload11.$el.querySelectorAll('.el-upload-list')[0].innerHTML = "" //去掉文件列表
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err.response.data.msg);
      })
    },
    // 上传 体验二维码
    uploadTestAttach(res, file, item) {
      var params = {
        url: res.data.url,
        orgId: item.orgId
      }
      uploadTestLink(params).then(res => {
        if (res.code == 200) {
          this.getdata()
          this.$message.success('上传成功！');
          this.$refs.upload12.clearFiles();
          this.fileList = [];
          // this.$refs.upload11.$el.querySelectorAll('.el-upload-list')[0].innerHTML = "" //去掉文件列表
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err.response.data.msg);
      })
    },
    beforeAvatarUpload(file) {
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改客户'
        queryOrgDetail(row.orgId).then(res => {
          this.form = res.data
        })
        // this.form = JSON.parse(JSON.stringify(row));
      } else {
        this.title = '添加客户'
        this.form = {};
      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          if (this.form.orgId) {

            // 修改
            updateOrg(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {
                  photo: ''
                }
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('修改失败，请稍后再试！')
              })
          } else {

            // 新增
            saveOrg(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {
                  photo: ''
                }
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.editFormShow = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {};
        this.editFormShow = false
      } else if (dialog == 'perm') {
        this.checkmenu = [];
        this.dataAccessshow = false
      } else if (dialog == 'pwd') {
        this.pwdShow = false
      }
    },

    handleDelete(index, row) {
      this.$confirm('确定要删除 ' + row.orgName + ' 客户吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          deleteOrg(row.orgId).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '客户 ' + row.orgName + ' 删除成功！'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    handleUpload(index, row) {

    }


  }

}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

/deep/ .el-dialog__body {
  padding: 10px 20px 20px 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/system/orgManage.vue